/* eslint-disable max-lines */
import { DashboardHeaderConstants } from '../../../../pages/Dashboard/DashboardHeader/DashboardHeaderConstants';
import { PermissionConstants } from '../../../../libs/models/UserModels';
import { routes } from '../../../../navigation/Routes';

export const SidebarLabels = {
  logout: 'Logout',
  asset: 'Asset Authorization',
  help: 'Help',
  operations: 'Deployments',
  analytics: 'Web Analytics',
  documentation: 'Documentation',
  keyContacts: 'Key Contacts',
  quickLinks: 'Quick Links',
  feedback: 'Feedback',
  feedbackResponse: 'Feedback',
  adminPanelLogout: 'Logout from DCA',
  profileSettings: 'My Profile Settings',
  userManagement: 'User Management',
  projectManagement: 'Account & Project Management',
  adminPanelTitle: 'Welcome Admin!',
  assessment: 'Assessments',
  migrate: 'Migrate',
  mobileViewNotFunctional:
    'This is a view-only app. For better experience, try the desktop version',
  industrySolutions: 'Industry Solutions',
  operationalTransformation: 'Operational Transformation',
  cloudEngineering: 'Cloud Engineering',
  migrationMordernization: 'Migration & Mordernization',
  techOperation: 'Tech Operation',
  configureCboJourney: 'Configure Your CBO Journey',
  transform: 'Transform',
  deliver: 'Deliver',
  manage: 'Manage',
  test: 'Test',
  assess: 'Assess',
  brownfield: 'Brownfield',
  dmap: 'DMAP',
  tourGuide: 'Tour Guide',
  githubLinks: 'Github Links',
  // Dashboard domain subcapabilities (match in-page tabs)
  // Cloud Strategy
  cloudStrategyDiscover: 'Discover',
  cloudStrategyAssess: 'Assess',
  cloudStrategyPlan: 'Plan',
  // Environment Build
  envBuildArchDesign: 'Architecture & Design',
  envBuildFoundations: 'Build Cloud Foundations',
  envBuildDeploymentPipelines: 'Deployment Pipelines',
  // Environment Runways
  runwaysEnvironments: 'Environments',
  runwaysWorkloadPatterns: 'Workload Patterns',
  runwaysAppsAndSolutions: 'Apps and Solutions',
  runwaysPlatforms: 'Platforms',
  // Site Reliability Engineering
  sreObservability: 'Observability',
  sreChaosEngineering: 'Chaos Engineering',
  sreReliabilityMetrics: 'Reliability Metrics',
  sreAiTokenomics: 'AI Tokenomics',
  // AI Engine
  aiAgentRegistry: 'Agent Registry',
  aiSkillsRegistry: 'Skills Registry',
  aiToolkitRegistry: 'Toolkit Registry',
  aiModelRegistry: 'Model Registry',
  aiLlmHealth: 'LLM Health',
  aiLlmSettings: 'LLM Settings',
  aiTaiGuardrails: 'TAI Guardrails',
  aiEngine: 'AI Engine',
};

export enum SideBarKey {
  DASHBOARD = 'dashboard',
  OPERATIONS = 'operations',
  ASSET_AUTHORISATION = 'assetAuthorisation',
  QUICKLINKS = 'quickLinks',
  WEB_ANALYTICS = 'webAnalytics',
  DOCUMENTATION = 'documentation',
  KEYCONTACTS = 'keyContacts',
  HELP = 'help',
  FEEDBACK = 'giveFeedback',
  FEEDBACK_RESPONSE = 'feedbackResponse',
  ACCOUNT_MANAGEMENT = 'dashboard/accountManagement',
  USER_MANAGEMENT = 'dashboard/userManagement',
  ASSESSMENT = 'assessment',
  FEEDBACK_FORM_ADMIN = 'feedback',
  DISCOVERASSESS = 'Foundation Assessment',
  OPERATE = 'Site reliability Engineering',
  MIGRATE_MODERNIZE = 'Foundation Readiness',
  CLOUD_SUMMARY = 'Foundation Summary',
  BUILD = 'Build Foundation',
  SECURITY = 'Security & Governance',
  LOGOUT = 'logOut',
  CBO_CONFIGURE_JOURNEY = 'cboConfigureJourney',
  CBO_PAGES = 'CBO pages',
  INDUSTRY_SOLUTIONS = 'Industry Solutions',
  OPERATIONAL_TRANSFORMATION = 'Operational Transformantion',
  CLOUD_ENGINEERING = 'Cloud Engineering',
  MIGRATE_MODERNIZATION = 'Migrate Modernization',
  TECH_OPERATION = 'Tech Operation',
  CONFIGURE_CBO_JOURNEY = 'Configure Your CBO Journey',
  MIGRATE = 'Migrate',
  BROWNFIELD = 'Brownfield',
  TEST = 'Test',
  DELIVER = 'Deliver',
  MANAGE = 'Manage',
  ASSESS = 'Assess',
  TRANSFORM = 'Transform',
  DMAP = 'DMAP',
  MODERNIZATION = 'MODERNIZATION',
  TOUR_GUIDE = 'TOUR_GUIDE',
  GITHUB_LINKS = 'GITHUB_LINKS',
  AI_ENGINE = 'AI Engine',
}

export interface ISidebarItem {
  key: SideBarKey;
  path: string;
  label: string;
  icon: string;
  activeIcon: string;
  disable: boolean;
  activeTabTitle?: string;
  type: ApplicationUserTypes;
  parent?: SideBarKey;
  hasChildren?: boolean;
  level?: number;
  menuSection?: menuSections;
  subMenuItems?: string[];
  permission?: string;
}

export enum ApplicationUserTypes {
  MIGRATE = 'MIGRATE',
  TANGRA = 'TANGRA',
}

export enum menuSections {
  TOP = 'top',
  BOTTOM = 'bottom',
}

export const MENU_ITEMS: ISidebarItem[] = [
  // Environment Summary - Top level
  {
    key: SideBarKey.CLOUD_SUMMARY,
    path: routes.dashboard,
    label: DashboardHeaderConstants.cloudSummary,
    icon: `/config-icons/sidebar/cloud-summary-icon-white.svg`,
    activeIcon: `/config-icons/sidebar/cloud-summary-icon.svg`,
    activeTabTitle: DashboardHeaderConstants.cloudSummary,
    level: 1,
    menuSection: menuSections.TOP,
    type: ApplicationUserTypes.TANGRA,
    disable: false,
  },
  // Discover & Assess - Top level with subcapabilities
  {
    key: SideBarKey.DISCOVERASSESS,
    path: routes.dashboard,
    label: DashboardHeaderConstants.discoverAccess,
    icon: `/config-icons/sidebar/discover_w.svg`,
    activeIcon: `/config-icons/sidebar/discover_b.svg`,
    activeTabTitle: DashboardHeaderConstants.discoverAccess,
    hasChildren: true,
    level: 1,
    menuSection: menuSections.TOP,
    type: ApplicationUserTypes.TANGRA,
    disable: false,
    subMenuItems: [
      'cloud-strategy-discover',
      'cloud-strategy-assess',
      'cloud-strategy-plan',
    ],
  },
  // Build & Deploy - Top level with subcapabilities
  {
    key: SideBarKey.BUILD,
    path: routes.dashboard,
    label: DashboardHeaderConstants.buildDeploy,
    icon: `/config-icons/sidebar/build_w.svg`,
    activeIcon: `/config-icons/sidebar/Build_b.svg`,
    activeTabTitle: DashboardHeaderConstants.buildDeploy,
    hasChildren: true,
    level: 1,
    menuSection: menuSections.TOP,
    type: ApplicationUserTypes.TANGRA,
    disable: false,
    subMenuItems: [
      'env-build-architecture-design',
      'env-build-foundations',
      'env-build-deployment-pipelines',
    ],
  },
  // Migrate & Modernize - Top level with subcapabilities
  {
    key: SideBarKey.MIGRATE_MODERNIZE,
    path: routes.dashboard,
    label: DashboardHeaderConstants.migrateModernize,
    icon: `/config-icons/sidebar/migrate_w.svg`,
    activeIcon: `/config-icons/sidebar/migrate_b.svg`,
    activeTabTitle: DashboardHeaderConstants.migrateModernize,
    hasChildren: true,
    level: 1,
    menuSection: menuSections.TOP,
    type: ApplicationUserTypes.TANGRA,
    disable: false,
    subMenuItems: [
      'runways-environments',
      'runways-workload-patterns',
      'runways-apps-solutions',
      'runways-platforms',
    ],
  },
  // Operate - Top level with subcapabilities
  {
    key: SideBarKey.OPERATE,
    path: routes.dashboard,
    label: DashboardHeaderConstants.operate,
    icon: `/config-icons/sidebar/operate_w.svg`,
    activeIcon: `/config-icons/sidebar/operate_b.svg`,
    activeTabTitle: DashboardHeaderConstants.operate,
    hasChildren: true,
    level: 1,
    menuSection: menuSections.TOP,
    type: ApplicationUserTypes.TANGRA,
    disable: false,
    subMenuItems: ['sre-observability', 'sre-chaos-engineering', 'sre-reliability-metrics', 'sre-ai-tokenomics'],
  },
  // Security & Governance - Top level
  {
    key: SideBarKey.SECURITY,
    path: routes.dashboard,
    label: DashboardHeaderConstants.securityGovernance,
    icon: `/config-icons/sidebar/security_w.svg`,
    activeIcon: `/config-icons/sidebar/security_b.svg`,
    activeTabTitle: DashboardHeaderConstants.securityGovernance,
    level: 1,
    menuSection: menuSections.TOP,
    type: ApplicationUserTypes.TANGRA,
    disable: false,
  },
  // AI Engine - Top level with subcapabilities
  {
    key: SideBarKey.AI_ENGINE,
    path: routes.dashboard,
    label: SidebarLabels.aiEngine,
    icon: `/config-icons/sidebar/ai-engine-white.svg`,
    activeIcon: `/config-icons/sidebar/ai-engine-black.svg`,
    activeTabTitle: DashboardHeaderConstants.aiEngine,
    hasChildren: true,
    level: 1,
    menuSection: menuSections.TOP,
    type: ApplicationUserTypes.TANGRA,
    disable: false,
    subMenuItems: [
      'ai-agent-registry',
      'ai-skills-registry',
      'ai-toolkit-registry',
      'ai-model-registry',
      'ai-llm-health',
      'ai-llm-settings',
      'ai-tai-guardrails',
    ],
  },
  // Cloud Strategy (Discover & Assess) Subcapabilities
  {
    key: 'cloud-strategy-discover' as SideBarKey,
    path: routes.dashboard,
    label: SidebarLabels.cloudStrategyDiscover,
    icon: `/config-icons/sidebar/discover_w.svg`,
    activeIcon: `/config-icons/sidebar/discover_b.svg`,
    activeTabTitle: DashboardHeaderConstants.discoverAccess,
    parent: SideBarKey.DISCOVERASSESS,
    type: ApplicationUserTypes.TANGRA,
    disable: false,
  },
  {
    key: 'cloud-strategy-assess' as SideBarKey,
    path: routes.dashboard,
    label: SidebarLabels.cloudStrategyAssess,
    icon: `/config-icons/sidebar/discover_w.svg`,
    activeIcon: `/config-icons/sidebar/discover_b.svg`,
    activeTabTitle: DashboardHeaderConstants.discoverAccess,
    parent: SideBarKey.DISCOVERASSESS,
    type: ApplicationUserTypes.TANGRA,
    disable: false,
  },
  {
    key: 'cloud-strategy-plan' as SideBarKey,
    path: routes.dashboard,
    label: SidebarLabels.cloudStrategyPlan,
    icon: `/config-icons/sidebar/discover_w.svg`,
    activeIcon: `/config-icons/sidebar/discover_b.svg`,
    activeTabTitle: DashboardHeaderConstants.discoverAccess,
    parent: SideBarKey.DISCOVERASSESS,
    type: ApplicationUserTypes.TANGRA,
    disable: false,
  },
  // Environment Build Subcapabilities
  {
    key: 'env-build-architecture-design' as SideBarKey,
    path: routes.dashboard,
    label: SidebarLabels.envBuildArchDesign,
    icon: `/config-icons/sidebar/build_w.svg`,
    activeIcon: `/config-icons/sidebar/Build_b.svg`,
    activeTabTitle: DashboardHeaderConstants.buildDeploy,
    parent: SideBarKey.BUILD,
    type: ApplicationUserTypes.TANGRA,
    disable: false,
  },
  {
    key: 'env-build-foundations' as SideBarKey,
    path: routes.dashboard,
    label: SidebarLabels.envBuildFoundations,
    icon: `/config-icons/sidebar/build_w.svg`,
    activeIcon: `/config-icons/sidebar/Build_b.svg`,
    activeTabTitle: DashboardHeaderConstants.buildDeploy,
    parent: SideBarKey.BUILD,
    type: ApplicationUserTypes.TANGRA,
    disable: false,
  },
  {
    key: 'env-build-deployment-pipelines' as SideBarKey,
    path: routes.dashboard,
    label: SidebarLabels.envBuildDeploymentPipelines,
    icon: `/config-icons/sidebar/build_w.svg`,
    activeIcon: `/config-icons/sidebar/Build_b.svg`,
    activeTabTitle: DashboardHeaderConstants.buildDeploy,
    parent: SideBarKey.BUILD,
    type: ApplicationUserTypes.TANGRA,
    disable: false,
  },
  // Environment Runways Subcapabilities
  {
    key: 'runways-environments' as SideBarKey,
    path: routes.dashboard,
    label: SidebarLabels.runwaysEnvironments,
    icon: `/config-icons/sidebar/migrate_w.svg`,
    activeIcon: `/config-icons/sidebar/migrate_b.svg`,
    activeTabTitle: DashboardHeaderConstants.migrateModernize,
    parent: SideBarKey.MIGRATE_MODERNIZE,
    type: ApplicationUserTypes.TANGRA,
    disable: false,
  },
  {
    key: 'runways-workload-patterns' as SideBarKey,
    path: routes.dashboard,
    label: SidebarLabels.runwaysWorkloadPatterns,
    icon: `/config-icons/sidebar/migrate_w.svg`,
    activeIcon: `/config-icons/sidebar/migrate_b.svg`,
    activeTabTitle: DashboardHeaderConstants.migrateModernize,
    parent: SideBarKey.MIGRATE_MODERNIZE,
    type: ApplicationUserTypes.TANGRA,
    disable: false,
  },
  {
    key: 'runways-apps-solutions' as SideBarKey,
    path: routes.dashboard,
    label: SidebarLabels.runwaysAppsAndSolutions,
    icon: `/config-icons/sidebar/migrate_w.svg`,
    activeIcon: `/config-icons/sidebar/migrate_b.svg`,
    activeTabTitle: DashboardHeaderConstants.migrateModernize,
    parent: SideBarKey.MIGRATE_MODERNIZE,
    type: ApplicationUserTypes.TANGRA,
    disable: false,
  },
  {
    key: 'runways-platforms' as SideBarKey,
    path: routes.dashboard,
    label: SidebarLabels.runwaysPlatforms,
    icon: `/config-icons/sidebar/migrate_w.svg`,
    activeIcon: `/config-icons/sidebar/migrate_b.svg`,
    activeTabTitle: DashboardHeaderConstants.migrateModernize,
    parent: SideBarKey.MIGRATE_MODERNIZE,
    type: ApplicationUserTypes.TANGRA,
    disable: false,
  },
  // Site Reliability Engineering Subcapabilities
  {
    key: 'sre-observability' as SideBarKey,
    path: routes.dashboard,
    label: SidebarLabels.sreObservability,
    icon: `/config-icons/sidebar/operate_w.svg`,
    activeIcon: `/config-icons/sidebar/operate_b.svg`,
    activeTabTitle: DashboardHeaderConstants.operate,
    parent: SideBarKey.OPERATE,
    type: ApplicationUserTypes.TANGRA,
    disable: false,
  },
  {
    key: 'sre-chaos-engineering' as SideBarKey,
    path: routes.dashboard,
    label: SidebarLabels.sreChaosEngineering,
    icon: `/config-icons/sidebar/operate_w.svg`,
    activeIcon: `/config-icons/sidebar/operate_b.svg`,
    activeTabTitle: DashboardHeaderConstants.operate,
    parent: SideBarKey.OPERATE,
    type: ApplicationUserTypes.TANGRA,
    disable: false,
  },
  {
    key: 'sre-reliability-metrics' as SideBarKey,
    path: routes.dashboard,
    label: SidebarLabels.sreReliabilityMetrics,
    icon: `/config-icons/sidebar/operate_w.svg`,
    activeIcon: `/config-icons/sidebar/operate_b.svg`,
    activeTabTitle: DashboardHeaderConstants.operate,
    parent: SideBarKey.OPERATE,
    type: ApplicationUserTypes.TANGRA,
    disable: false,
  },
  {
    key: 'sre-ai-tokenomics' as SideBarKey,
    path: routes.dashboard,
    label: SidebarLabels.sreAiTokenomics,
    icon: `/config-icons/sidebar/operate_w.svg`,
    activeIcon: `/config-icons/sidebar/operate_b.svg`,
    activeTabTitle: DashboardHeaderConstants.operate,
    parent: SideBarKey.OPERATE,
    type: ApplicationUserTypes.TANGRA,
    disable: false,
  },
  // AI Engine Subcapabilities
  {
    key: 'ai-agent-registry' as SideBarKey,
    path: routes.dashboard,
    label: SidebarLabels.aiAgentRegistry,
    icon: `/config-icons/sidebar/ai-engine-white.svg`,
    activeIcon: `/config-icons/sidebar/ai-engine-black.svg`,
    activeTabTitle: DashboardHeaderConstants.aiEngine,
    parent: SideBarKey.AI_ENGINE,
    type: ApplicationUserTypes.TANGRA,
    disable: false,
  },
  {
    key: 'ai-skills-registry' as SideBarKey,
    path: routes.dashboard,
    label: SidebarLabels.aiSkillsRegistry,
    icon: `/config-icons/sidebar/ai-engine-white.svg`,
    activeIcon: `/config-icons/sidebar/ai-engine-black.svg`,
    activeTabTitle: DashboardHeaderConstants.aiEngine,
    parent: SideBarKey.AI_ENGINE,
    type: ApplicationUserTypes.TANGRA,
    disable: false,
  },
  {
    key: 'ai-toolkit-registry' as SideBarKey,
    path: routes.dashboard,
    label: SidebarLabels.aiToolkitRegistry,
    icon: `/config-icons/sidebar/ai-engine-white.svg`,
    activeIcon: `/config-icons/sidebar/ai-engine-black.svg`,
    activeTabTitle: DashboardHeaderConstants.aiEngine,
    parent: SideBarKey.AI_ENGINE,
    type: ApplicationUserTypes.TANGRA,
    disable: false,
  },
  {
    key: 'ai-model-registry' as SideBarKey,
    path: routes.dashboard,
    label: SidebarLabels.aiModelRegistry,
    icon: `/config-icons/sidebar/ai-engine-white.svg`,
    activeIcon: `/config-icons/sidebar/ai-engine-black.svg`,
    activeTabTitle: DashboardHeaderConstants.aiEngine,
    parent: SideBarKey.AI_ENGINE,
    type: ApplicationUserTypes.TANGRA,
    disable: false,
  },
  {
    key: 'ai-llm-health' as SideBarKey,
    path: routes.dashboard,
    label: SidebarLabels.aiLlmHealth,
    icon: `/config-icons/sidebar/ai-engine-white.svg`,
    activeIcon: `/config-icons/sidebar/ai-engine-black.svg`,
    activeTabTitle: DashboardHeaderConstants.aiEngine,
    parent: SideBarKey.AI_ENGINE,
    type: ApplicationUserTypes.TANGRA,
    disable: false,
  },
  {
    key: 'ai-llm-settings' as SideBarKey,
    path: routes.dashboard,
    label: SidebarLabels.aiLlmSettings,
    icon: `/config-icons/sidebar/ai-engine-white.svg`,
    activeIcon: `/config-icons/sidebar/ai-engine-black.svg`,
    activeTabTitle: DashboardHeaderConstants.aiEngine,
    parent: SideBarKey.AI_ENGINE,
    type: ApplicationUserTypes.TANGRA,
    disable: false,
  },
  {
    key: 'ai-tai-guardrails' as SideBarKey,
    path: routes.dashboard,
    label: SidebarLabels.aiTaiGuardrails,
    icon: `/config-icons/sidebar/ai-engine-white.svg`,
    activeIcon: `/config-icons/sidebar/ai-engine-black.svg`,
    activeTabTitle: DashboardHeaderConstants.aiEngine,
    parent: SideBarKey.AI_ENGINE,
    type: ApplicationUserTypes.TANGRA,
    disable: false,
  },
  /* KEEPING FOR FUTURE REFERENCE */
  // {
  //   key: SideBarKey.ASSET_AUTHORISATION,
  //   path: routes.assetAuthorisation,
  //   label: SidebarLabels.asset,
  //   icon: `/config-icons/sidebar/asset-white.svg`,
  //   activeIcon: `/config-icons/sidebar/asset-black.svg`,
  //   level: 1,
  //   menuSection: menuSections.TOP,
  //   type: ApplicationUserTypes.TANGRA,
  //   disable: false,
  // // },
  // {
  //   key: SideBarKey.OPERATIONS,
  //   path: routes.operations,
  //   label: SidebarLabels.operations,
  //   icon: `/config-icons/sidebar/Operations_White.svg`,
  //   activeIcon: `/config-icons/sidebar/Operations_Black.svg`,
  //   level: 1,
  //   menuSection: menuSections.TOP,
  //   type: ApplicationUserTypes.TANGRA,
  //   disable: false,
  // },
  {
    key: SideBarKey.WEB_ANALYTICS,
    path: routes.webAnalytics,
    label: SidebarLabels.analytics,
    icon: `/config-icons/sidebar/barchart_white.svg`,
    activeIcon: `/config-icons/sidebar/barchart_black.svg`,
    level: 1,
    parent: SideBarKey.HELP,
    type: ApplicationUserTypes.TANGRA,
    disable: false,
  },
  {
    key: SideBarKey.DOCUMENTATION,
    path: routes.documentation,
    label: SidebarLabels.documentation,
    icon: `/config-icons/sidebar/documentation-light.svg`,
    activeIcon: `/config-icons/sidebar/documentation-dark.svg`,
    level: 1,
    parent: SideBarKey.HELP,
    type: ApplicationUserTypes.TANGRA,
    disable: false,
  },
  {
    key: SideBarKey.QUICKLINKS,
    path: routes.quickLinks,
    label: SidebarLabels.quickLinks,
    icon: `/config-icons/sidebar/.svg`,
    activeIcon: `/config-icons/sidebar/.svg`,
    level: 1,
    menuSection: menuSections.TOP,
    type: ApplicationUserTypes.TANGRA,
    disable: true,
  },
  {
    key: SideBarKey.HELP,
    path: routes.dashboard,
    label: SidebarLabels.help,
    icon: `/config-icons/sidebar/Help_White.svg`,
    activeIcon: `/config-icons/sidebar/Help_Black.svg`,
    hasChildren: true,
    level: 1,
    menuSection: menuSections.BOTTOM,
    type: ApplicationUserTypes.TANGRA,
    disable: false,
    subMenuItems: [
      SideBarKey.KEYCONTACTS,
      SideBarKey.WEB_ANALYTICS,
      SideBarKey.DOCUMENTATION,
      SideBarKey.TOUR_GUIDE,
      SideBarKey.GITHUB_LINKS,
    ],
  },
  {
    key: SideBarKey.TOUR_GUIDE,
    path: routes.dashboard,
    label: SidebarLabels.tourGuide,
    icon: `/config-icons/sidebar/tour_guide_white.svg`,
    activeIcon: `/config-icons/sidebar/tour_guide_black.svg`,
    parent: SideBarKey.HELP,
    type: ApplicationUserTypes.TANGRA,
    disable: false,
    level: 1,
  },
  {
    key: SideBarKey.GITHUB_LINKS,
    path: routes.dashboard,
    label: SidebarLabels.githubLinks,
    icon: `/config-icons/sidebar/github_link_white.svg`,
    activeIcon: `/config-icons/sidebar/github_link_black.svg`,
    parent: SideBarKey.HELP,
    type: ApplicationUserTypes.TANGRA,
    disable: false,
  },
  {
    key: SideBarKey.KEYCONTACTS,
    path: routes.keyContacts,
    label: SidebarLabels.keyContacts,
    icon: `/config-icons/sidebar/contacts_white.svg`,
    activeIcon: `/config-icons/sidebar/contacts_black.svg`,
    level: 1,
    parent: SideBarKey.HELP,
    type: ApplicationUserTypes.TANGRA,
    disable: false,
  },
  {
    key: SideBarKey.FEEDBACK_FORM_ADMIN,
    path: routes.feedback,
    label: SidebarLabels.feedback,
    icon: `/config-icons/sidebar/feedback-response-white.svg`,
    activeIcon: `/config-icons/sidebar/feedback-response-black.svg`,
    level: 1,
    menuSection: menuSections.BOTTOM,
    type: ApplicationUserTypes.TANGRA,
    disable: false,
  },
  {
    key: SideBarKey.FEEDBACK,
    path: routes.giveFeedback,
    label: SidebarLabels.feedbackResponse,
    icon: `/config-icons/sidebar/feedback-response-white.svg`,
    activeIcon: `/config-icons/sidebar/feedback-response-black.svg`,
    level: 1,
    menuSection: menuSections.BOTTOM,
    type: ApplicationUserTypes.TANGRA,
    disable: false,
  },
  {
    key: SideBarKey.FEEDBACK_RESPONSE,
    path: routes.feedbackResponse,
    label: DashboardHeaderConstants.cloudSummary,
    icon: `/config-icons/sidebar/.svg`,
    activeIcon: `/config-icons/sidebar/.svg`,
    type: ApplicationUserTypes.TANGRA,
    disable: true,
  },
  {
    key: SideBarKey.ASSESSMENT,
    path: routes.assessment,
    label: SidebarLabels.assessment,
    icon: `/config-icons/sidebar/.svg`,
    activeIcon: `/config-icons/sidebar/.svg`,
    type: ApplicationUserTypes.TANGRA,
    disable: true,
  },

  {
    key: SideBarKey.DMAP,
    path: routes.dashboard,
    label: SidebarLabels.dmap,
    icon: `/config-icons/sidebar/dmap/dmap-white.svg`,
    activeIcon: `/config-icons/sidebar/dmap/dmap-black.svg`,
    menuSection: menuSections.TOP,
    type: ApplicationUserTypes.TANGRA,
    level: 1,
    disable: false,
    hasChildren: true,
    permission: PermissionConstants.canViewDMAP,
    subMenuItems: [
      SideBarKey.MODERNIZATION,
      SideBarKey.ASSESS,
      SideBarKey.MIGRATE,
      SideBarKey.TRANSFORM,
      SideBarKey.TEST,
      SideBarKey.MANAGE,
      SideBarKey.DELIVER,
    ],
  },
  {
    key: SideBarKey.MODERNIZATION,
    path: routes.assess,
    label: DashboardHeaderConstants.modernization,
    icon: `/config-icons/sidebar/dmap/modernization-white.svg`,
    activeIcon: `/config-icons/sidebar/dmap/modernization-black.svg`,
    activeTabTitle: DashboardHeaderConstants.modernization,
    parent: SideBarKey.DMAP,
    type: ApplicationUserTypes.TANGRA,
    disable: false,
  },
  {
    key: SideBarKey.ASSESS,
    path: routes.assess,
    label: SidebarLabels.assess,
    icon: `/config-icons/sidebar/dmap/assess-white.svg`,
    activeIcon: `/config-icons/sidebar/dmap/assess-black.svg`,
    activeTabTitle: DashboardHeaderConstants.assess,
    parent: SideBarKey.DMAP,
    type: ApplicationUserTypes.TANGRA,
    disable: false,
  },
  {
    key: SideBarKey.MIGRATE,
    path: routes.migrate,
    label: SidebarLabels.migrate,
    icon: `/config-icons/sidebar/dmap/migrate-white.svg`,
    activeIcon: `/config-icons/sidebar/dmap/migrate-black.svg`,
    activeTabTitle: DashboardHeaderConstants.migrate,
    parent: SideBarKey.DMAP,
    type: ApplicationUserTypes.TANGRA,
    disable: false,
  },
  {
    key: SideBarKey.BROWNFIELD,
    path: routes.brownfield,
    label: SidebarLabels.brownfield,
    icon: `/config-icons/sidebar/dmap/transform-white.svg`,
    activeIcon: `/config-icons/sidebar/dmap/transform-black.svg`,
    activeTabTitle: DashboardHeaderConstants.transform,
    parent: SideBarKey.DMAP,
    type: ApplicationUserTypes.TANGRA,
    disable: false,
  },
  {
    key: SideBarKey.TEST,
    path: routes.test,
    label: DashboardHeaderConstants.test,
    icon: `/config-icons/sidebar/dmap/test-white.svg`,
    activeIcon: `/config-icons/sidebar/dmap/test-black.svg`,
    activeTabTitle: DashboardHeaderConstants.test,
    parent: SideBarKey.DMAP,
    type: ApplicationUserTypes.TANGRA,
    disable: false,
  },
  {
    key: SideBarKey.MANAGE,
    path: routes.manage,
    label: DashboardHeaderConstants.manage,
    icon: `/config-icons/sidebar/dmap/manage-white.svg`,
    activeIcon: `/config-icons/sidebar/dmap/manage-black.svg`,
    activeTabTitle: DashboardHeaderConstants.manage,
    parent: SideBarKey.DMAP,
    type: ApplicationUserTypes.TANGRA,
    disable: false,
  },
  {
    key: SideBarKey.DELIVER,
    path: routes.deliver,
    label: DashboardHeaderConstants.deliver,
    icon: `/config-icons/sidebar/dmap/deliver-white.svg`,
    activeIcon: `/config-icons/sidebar/dmap/deliver-black.svg`,
    activeTabTitle: DashboardHeaderConstants.deliver,
    parent: SideBarKey.DMAP,
    type: ApplicationUserTypes.TANGRA,
    disable: false,
  },
  // {
  //   key: SideBarKey.CBO_PAGES,
  //   path: routes.dashboard,
  //   label: 'Sections',
  //   icon: `/config-icons/sidebar/operate_w.svg`,
  //   activeIcon: `/config-icons/sidebar/operate_b.svg`,
  //   menuSection: menuSections.TOP,
  //   type: ApplicationUserTypes.MIGRATE,
  //   level: 1,
  //   hasChildren: true,
  //   disable: false,
  // },
  // {
  //   key: SideBarKey.INDUSTRY_SOLUTIONS,
  //   path: routes.dashboard,
  //   label: SidebarLabels.industrySolutions,
  //   icon: `/config-icons/sidebar/cloud-summary-icon-white.svg`,
  //   activeIcon: `/config-icons/sidebar/cloud-summary-icon.svg`,
  //   parent: SideBarKey.CBO_PAGES,
  //   type: ApplicationUserTypes.MIGRATE,
  //   disable: false,
  // },
  // {
  //   key: SideBarKey.OPERATIONAL_TRANSFORMATION,
  //   path: routes.dashboard,
  //   label: SidebarLabels.operationalTransformation,
  //   icon: `/config-icons/sidebar/cloud-summary-icon-white.svg`,
  //   activeIcon: `/config-icons/sidebar/cloud-summary-icon.svg`,
  //   parent: SideBarKey.CBO_PAGES,
  //   type: ApplicationUserTypes.MIGRATE,
  //   disable: false,
  // },
  // {
  //   key: SideBarKey.CLOUD_ENGINEERING,
  //   path: routes.dashboard,
  //   label: SidebarLabels.cloudEngineering,
  //   icon: `/config-icons/sidebar/cloud-summary-icon-white.svg`,
  //   activeIcon: `/config-icons/sidebar/cloud-summary-icon.svg`,
  //   parent: SideBarKey.CBO_PAGES,
  //   type: ApplicationUserTypes.MIGRATE,
  //   disable: false,
  // },
  // {
  //   key: SideBarKey.MIGRATE_MODERNIZATION,
  //   path: routes.dashboard,
  //   label: SidebarLabels.migrationMordernization,
  //   icon: `/config-icons/sidebar/cloud-summary-icon-white.svg`,
  //   activeIcon: `/config-icons/sidebar/cloud-summary-icon.svg`,
  //   parent: SideBarKey.CBO_PAGES,
  //   type: ApplicationUserTypes.MIGRATE,
  //   disable: false,
  // },
  // {
  //   key: SideBarKey.TECH_OPERATION,
  //   path: routes.dashboard,
  //   label: SidebarLabels.techOperation,
  //   icon: `/config-icons/sidebar/cloud-summary-icon-white.svg`,
  //   activeIcon: `/config-icons/sidebar/cloud-summary-icon.svg`,
  //   parent: SideBarKey.CBO_PAGES,
  //   type: ApplicationUserTypes.MIGRATE,
  //   disable: false,
  // },
  // {
  //   key: SideBarKey.CONFIGURE_CBO_JOURNEY,
  //   path: routes.cboConfigureJourney,
  //   label: SidebarLabels.configureCboJourney,
  //   icon: `/config-icons/sidebar/Operations_White.svg`,
  //   activeIcon: `/config-icons/sidebar/Operations_Black.svg`,
  //   menuSection: menuSections.TOP,
  //   type: ApplicationUserTypes.MIGRATE,
  //   level: 1,
  //   disable: false,
  // },
];
